import { render } from "./SendSummaryBox.vue?vue&type=template&id=1658700e&scoped=true&ts=true"
import script from "./SendSummaryBox.vue?vue&type=script&lang=ts"
export * from "./SendSummaryBox.vue?vue&type=script&lang=ts"

import "./SendSummaryBox.vue?vue&type=style&index=0&id=1658700e&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1658700e"]])

export default __exports__